import { QueryClient } from "@tanstack/react-query";
import { configureSharedAPI } from "@rebuild/shared";
import { Provider } from "@/providers/http.provider";

// Configure shared API client with base URL and auth headers
configureSharedAPI({
  baseUrl: import.meta.env.VITE_API_URL,
  auth: {
    getToken: () => localStorage.getItem("lassoToken") ?? Provider.lassoToken,
    getUid: () => Provider.uid,
  },
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});
